export default __webpack_public_path__ + "static/media/Show.5ee4c8ab.svg";